import { DeleteOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { CSSProperties, FC, PropsWithChildren } from 'react';
import './XmScopeLock.less';

const SCOPE_LOCK_ITEM_TEXT = 'Outside your device-manager scope';
export const SCOPE_LOCK_TAG_TEXT = 'Points to items outside your device-manager scope';
export const SCOPE_FILTER_LABEL = 'Hide out of scope';

interface Props {
  readonly tooltip?: string;
}

interface LockProps extends Props {
  readonly className?: string;
  readonly style?: CSSProperties;
}

export const XmScopeLock: FC<LockProps> = ({ tooltip = SCOPE_LOCK_ITEM_TEXT, className, style }) => (
  <Tooltip title={tooltip}>
    <DeleteOutlined aria-label={tooltip} className={['xm-scope-lock', className].join(' ').trim()} style={style} />
  </Tooltip>
);

/** Disabled controls never fire hover, so the tooltip listens on this wrapper. */
export const XmScopeLockTooltip: FC<PropsWithChildren<Props>> = ({ tooltip = SCOPE_LOCK_ITEM_TEXT, children }) => (
  <Tooltip title={tooltip}>
    <span className='xm-scope-lock-wrap'>{children}</span>
  </Tooltip>
);
